import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { MunicipalPropertyUsageListQuery } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { DEFAULT_STALE_TIME_MS } from "@/services/react-query.service/stale-time";
import { useInfiniteQuery } from "@tanstack/react-query";

import { MUNICIPAL_PROPERTY_USAGE_LIST_QUERY_DOCUMENT } from "./municipal-property-usage-list-query.gql";

const USAGE_PAGE_SIZE: number = 50;

export function useMunicipalPropertyUsageList(propertyId: string) {
  const { currentWorkspace }: ReturnType<typeof useCurrentWorkspaceContext> = useCurrentWorkspaceContext();
  return useInfiniteQuery({
    queryKey: queryKeys.municipalProperties.usage(propertyId),
    queryFn: async ({ pageParam }): Promise<MunicipalPropertyUsageListQuery["municipalPropertyUsageList"]> => {
      const response: MunicipalPropertyUsageListQuery = await createOperationClient(
        "MunicipalPropertyUsageList",
      ).request(MUNICIPAL_PROPERTY_USAGE_LIST_QUERY_DOCUMENT, { id: propertyId,
        first: USAGE_PAGE_SIZE,
        after: pageParam,
      });
      return response.municipalPropertyUsageList;
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? (lastPage.endCursor ?? undefined) : undefined),
    enabled: !!propertyId,
    staleTime: DEFAULT_STALE_TIME_MS,
    meta: { workspaceId: currentWorkspace.id },
  });
}
